export default "__VITE_ASSET__Ccyz7GYh__"